import {useSetAtom} from 'jotai';
import {toast} from '@/components/HotToast';
import {useGA4WithParams} from '@/hooks/tracking';
import {mapActionModeAtom} from '@/map/atom';
import {MAX_VISIBLE_ZOOM_METER} from '@/map/constants';
import {MapActionTypes} from '@/map/enums';
import {useVisibleZoomLevel} from '@/map/hooks';
import {ContextMenuProps} from './index.d';
import {Item} from './StyledComponents';

interface IProps extends ContextMenuProps {}

export const MeasureDistance = ({coords, clearContextMenu}: IProps) => {
  const setActionMode = useSetAtom(mapActionModeAtom);
  const isAvailableLevel = useVisibleZoomLevel(MAX_VISIBLE_ZOOM_METER.ruler);

  const tracking = useGA4WithParams();

  const measure = () => {
    if (!isAvailableLevel) {
      toast(
        '현재 배율에서는 거리 측정을 할 수 없습니다.<br /><strong>지도를 좀 더 확대</strong>해 주세요.'
      );
      return null;
    }

    if (coords) {
      setActionMode({
        mode: MapActionTypes.ruler,
        options: {
          point: coords,
        },
      });
      tracking('measure_distance_context');
    }

    clearContextMenu?.();
  };

  return <Item onClick={measure}>거리 측정</Item>;
};
